import {BehaviorSubject} from 'rxjs';
import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {array2Map} from '@/helper/array';

export const contracts$ = new BehaviorSubject([]);
export const leverageMargins$ = new BehaviorSubject([]);

// 合约抵押品配置
export const contractCollaterals$ = new BehaviorSubject([]);
// 合约抵押品流动性配置
export const contractCollateralLiquility$ = new BehaviorSubject([]);
export const contractRepayOptions$ = contractCollaterals$.pipe(map((items) => items.filter((item) => item.canRepay).map((item) => ({value: item.currency, text: item.currency, name: item.name}))));

export const contractsCache$ = contracts$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'symbol')),
  startWith(new Map()),
  shareReplay(1)
);

export const leverageMarginsCache$ = leverageMargins$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'index_id')),
  startWith(new Map()),
  shareReplay(1)
);

export const contractCollateralsCache$ = contractCollaterals$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'currency')),
  startWith(new Map()),
  shareReplay(1)
);
